import {inject, Injectable} from '@angular/core';
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {GetSelectDataParams, RecordData, SelectData} from "../../../../../../../core/types/records-table.types";
import {CreateQualityControlData} from "../types/create-quality-control.types";
import {qualityControlResourceType} from "../configs/create-quality-control-config";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class CreateQualityControlService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public createQualityControlData(params: CreateQualityControlData): Promise<RecordData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateQualityControlData, RecordData>(params, qualityControlResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getSelectData(params :GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(params).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
